import { useQuery, useMutation } from "@tanstack/react-query";
import { instanceWithToken } from "../../axios.config";

export const useCart = (params) => {
  return useQuery({
    queryKey: ["cart", params],
    queryFn: async () => {
      const {
        data: { data },
      } = await instanceWithToken.get("cart", { params });
      return data;
    },
  });
};

export const useAddItem = () => {
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await instanceWithToken.post("cart/item/add", body);
      return data;
    },
  });
};

export const useDecreaseItem = () => {
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await instanceWithToken.post("cart/item/decrease", body);
      return data;
    },
  });
};

export const useRemoveItem = () => {
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await instanceWithToken.post("cart/item/remove", body);
      return data;
    },
  });
};

export const useShipping = (params) => {
  return useQuery({
    queryKey: ["cart", params],
    queryFn: async () => {
      const { data } = await instanceWithToken.get("shipping", { params });
      return data;
    },
  });
};
